module.exports = __webpack_public_path__ + "img/1.afcbfe81.svg";